<template>
  <div
    class="select-button"
    :class="{voteVasGiven:isGray}"
    @click="action"
    v-on:keyup.enter="action"
    tabindex="0"
    :aria-label="buttonName"
  >
    {{ buttonName }}
  </div>
</template>

<script>
export default {
  name: 'select-button',
  props: ['buttonName', 'action'],
  components: {
  },
  data() {
    return {
    }
  },
  computed: {
    isGray(){
      if(this.buttonName === "wybrane"){
        return true;
      }
      return false;
    }
  },
  mounted() {

  }
}
</script>

<style scoped lang="scss">
  .select-button {
    background-color: #af2f82;
    background-image: linear-gradient(to right, #df2860, #af2f82);
    color: #fafafa;
    border-radius: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 2.5rem;
    font-family: 'Poppins', sans-serif;
    font-size: 0.9rem;
    text-transform: uppercase;
    margin: 1rem 0;
    cursor: pointer;
  }
  .voteVasGiven {
    background-color: #ebe6e6;
    background-image: none;
    color: #e14c79;
  }
</style>
